import { Link } from 'react-router-dom'

import { Avatar } from '@/components/ui/avatar'
import { Typography } from '@/components/ui/typography'
import { routerFactory } from '@/factories'
import { getAssetLink } from '@/helpers/get-asset-link'
import { UnitLeaseResident } from '@/models/features'
import { getResidentFullName } from '@/utils/units'

import * as S from './resident-cell.styled'

export interface ResidentCellProps {
  resident: UnitLeaseResident
}

export const ResidentCell = ({ resident }: ResidentCellProps) => {
  const fullName = getResidentFullName(resident)

  return (
    <S.Cell>
      <Avatar
        alt={fullName}
        size="small"
        src={getAssetLink({ file: resident.avatar ?? undefined, path: 'chitown-avatar/avatar' })}
      />
      <Typography as="span" size="text-small" weight="medium" color="black800" breakLines={1}>
        {resident.clientId === null ? (
          fullName || resident.email
        ) : (
          <Link
            to={routerFactory.getPathString({
              params: { clientId: resident.clientId },
              path: '/dashboard/clients/:clientId',
            })}
            style={{ color: 'inherit', textDecoration: 'underline' }}
            onClick={(event) => event.stopPropagation()}
          >
            {fullName || resident.email}
          </Link>
        )}
      </Typography>
    </S.Cell>
  )
}
